export default __webpack_public_path__ + "media/images/data_gear-14fcbc3e563bb7f507ea399d3a56a0cd.png";